<template>
  <div class="flex middle column">
    <div class="w1200 w100">
      <section class="grid-flex w100 center column middle">
        <h2>Estamos te redirecionando. Aguarde!</h2>
        <div class="margin-top-l">
          <a :href="url">Clique Aqui caso você não seja redirecionado!</a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";
export default {
  name: "subscription-redirect",
  components: {},
  props: ['flow'],
  data() {
    return {
      urlBase: 'https://unicotracker.com.br/escolha-seu-plano.html',
      urlBaseSubAccount: 'https://unicotracker.com.br/upgrade-clientes.html',
      urlBaseWhatsapp: 'https://unicotracker.com.br/upgrade-whatsapp.html',
      urlBaseAdPixelPro: 'https://adpixel.pro/plans.html',
    };
  },
  mounted() {
    setTimeout(() => {
      document.location.href = this.url
    }, 1000)
  },
  computed: {
      ...mapState({
          account: (state) => state.account,
      }),
      isAdPixelPro() {
        const currentDomain = window.location.hostname;
        if (currentDomain.includes("adpixel.pro")) {
          return true
        }

        return false
      },
      url() {
        if (!this.account) {
          return
        }
        
        var url = this.urlBase
        if (this.isAdPixelPro) {
          url = this.urlBaseAdPixelPro
        }

        if (this.flow && this.flow == 'whatsapp') {
          url = this.urlBaseWhatsapp
        }

        if (this.flow && this.flow == 'cliente') {
          url = this.urlBaseSubAccount
        }

        if (this.account.afiliate_code) {
          return `${url}?freemium=true&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}&afid=${this.account.afiliate_kiwify_code}`
        }

        return `${url}?freemium=true&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}`
      }
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>
